import clc from 'console-log-colors';
import {PrimeNGConfig} from 'primeng/api';

import {Injector, signal} from '@angular/core';
import {LanguageService} from '@core/language';
import {StorageService} from '@core/storage';
import {GlobalsService, RouteHistoryService} from '@global-data';
import {TraceService} from '@sentry/angular';
import {environment, isDevMode, LanguageType, setMainInjector} from '@shared-types';
import {DeviceService} from '@shared/device';
import canvasSize from 'canvas-size';
import {pdfDefaultOptions} from 'ngx-extended-pdf-viewer';
import {CompanyManifestService} from '@company-settings/data-access';

export function AppInitializer(
	injector: Injector,
	storageService: StorageService,
	languageService: LanguageService,
	deviceService: DeviceService,
	primeNGConfig: PrimeNGConfig,
	_RouteHistoryService: RouteHistoryService,
	_globalService: GlobalsService,
	_traceService: TraceService,
	_companyManifestService: CompanyManifestService, // Replace with actual type if available
) {
	return async () => {
		if (isDevMode()) {
			const currentLang: LanguageType = languageService.currentLang$();
			const deviceType: string = deviceService.deviceType();
			console.group(clc.cyan('------------------ Info	------------------'));
			console.info(clc.cyan('Current Language:'), currentLang);
			console.info(clc.cyan('Device Type:'), deviceType);
			console.info(clc.cyan('Environment:'), environment);
			console.groupEnd();
		}
		setMainInjector(injector);
		storageService.init();
		environment.deviceType = deviceService.deviceType();
		// primeNGConfig:
		initPrimeNgConfig(primeNGConfig);
		// await configureMaxCanvasPixels();
	};
}

function initPrimeNgConfig(primeNGConfig: PrimeNGConfig): void {
	// input style:
	primeNGConfig.inputStyle = signal('outlined');
}

async function configureMaxCanvasPixels() {
	const localMaxCanvasPixels = localStorage.getItem('MAX_CANVAS_PIXELS');
	let calculatedMaxCanvasPixels = localMaxCanvasPixels ? Number(localMaxCanvasPixels) : 16777216;
	if (!localMaxCanvasPixels || isNaN(calculatedMaxCanvasPixels)) {
		try {
			if (typeof canvasSize !== 'undefined' && typeof canvasSize.maxArea === 'function') {
				const maxAreaResult = await canvasSize.maxArea();
				calculatedMaxCanvasPixels = maxAreaResult.width * maxAreaResult.height;
				localStorage.setItem('MAX_CANVAS_PIXELS', calculatedMaxCanvasPixels.toString());
			} else {
				console.warn('[AppInitializer] canvas-size library is not available. maxCanvasPixels will not be set.');
			}
		} catch (error) {
			console.error('[AppInitializer] error while calculating maxCanvasPixels:', error);
		}
	}
	pdfDefaultOptions.maxCanvasPixels = calculatedMaxCanvasPixels;
}
